import { Component, OnInit, ViewChild } from "@angular/core";
import { UserBehaviorService } from "../../services/user-behavior/user-behavior.service";
import { MatSort, MatTableDataSource } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-project-overview-admin",
  templateUrl: "./project-overview-admin.component.html",
  styleUrls: ["./project-overview-admin.component.scss"],
})
export class ProjectOverviewAdminComponent implements OnInit {
  loading = true;
  projects = [];

  referringDate = new Date(1900, 0, 0);
  dataSource = new MatTableDataSource([]);

  constructor(
    private userBehaviorService: UserBehaviorService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  displayedColumns = [
    "name",
    "owner",
    "epicCount",
    "itemCount",
    "lastItemOperation",
    "sprintCount",
    "lastSprintOperation",
    "annotationCount",
    "lastAnnotationOperation",
    "retroCount",
    "lastRetroOperation",
    "coachCount",
    "jiraSync",
  ];
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    //get all projects
    this.userBehaviorService.getAllProjects().then((response) => {
      this.projects = response.ProjectResponse.projects;
      this.createDataSource(this.projects);
      this.dataSource.sort = this.sort;
      this.loading = false;
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  createDataSource(projects) {
    // this.loading = true;
    // console.log(projects);

    this.dataSource = new MatTableDataSource([]);
    let dataObjects = this.dataSource.data;
    projects.forEach((element) => {
      dataObjects.push({
        name: element.name,
        owner: element.ownerId,
        epicCount: element.numOfThemes,
        itemCount: element.numOfFeatures,
        lastItemOperation: new Date(element.recentItem),
        sprintCount: element.numOfSprints,
        lastSprintOperation: new Date(element.recentSprint),
        annotationCount: element.numOfAnnotations,
        lastAnnotationOperation: new Date(element.recentAnnotation),
        retroCount: element.numOfRetrospectives,
        lastRetroOperation: new Date(element.recentRetrospective),
        coachCount: element.numOfParticipants,
        jiraSync: element.issueTrackerLink.issueTracker ? true : false,
      });
    });
    this.dataSource.data = dataObjects;
    // this.loading = false;
  }

  userOverviewClicked() {
    this.router.navigate(["/userBehavior"]);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/project-overview-admin/project-overview-admin.component.ts